export const api = window.location.hostname === 'localhost' ? 'https://brokers.thefive.ru/ajax/index.php' : '/ajax/index.php'
